class Pricing {
    constructor() {
        require('../../../sass/pages/pricing.sass');
    }
}

export default Pricing;